exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spec-link {\n\tcolor: #366ae2;\n  font-size: 1.2em;\n  font-weight: bold;\n}\n\n.spec-link:focus::before,\n.spec-link:hover::before {\n  background: #366ae2;\n}\n\nh2 .small {\n  color: #000;\n  font-size: .5em;\n  display: inline-block;\n  vertical-align: baseline;\n  line-height: 43px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /root/anvel/angular/app/components/products/specs/products-specs.css
// module id = ../../../../../angular/app/components/products/specs/products-specs.css
// module chunks = 1